module.exports = __webpack_public_path__ + "e33346c55ada5270705fc13bab179556.svg";